import React from 'react';

/*
  Simple HTML5 file input wrapper
  usage: <FileInput id={uniqueId} handleFile={callback} accept={extensionsString} label="Label" />
    handleFile(file:File):void;
*/
export default class FileInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) {
      this.props.handleFile(files[0]);
    }
    e.target.value = '';
  }
  render() {
    return (
      <DragDropFile handleFile={this.props.handleFile}>
        <label htmlFor={this.props.id} title={this.props.title} className="btn">
          {this.props.label}
          <input
            type="file"
            style={{ display: 'none' }}
            id={this.props.id}
            accept={this.props.accept}
            onChange={this.handleChange}
          />
        </label>
      </DragDropFile>
    );
  }
}

/*
  Simple HTML5 file drag-and-drop wrapper
  usage: <DragDropFile handleFile={handleFile}>...</DragDropFile>
    handleFile(file:File):void;
*/
export class DragDropFile extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
  }

  suppress(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }

  onDrop(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    const files = evt.dataTransfer.files;
    if (files && files[0]) {
      this.props.handleFile(files[0]);
    }
    this.value = '';
  }
  render() {
    return (
      <div
        style={{ display: 'inline-block' }}
        onDrop={this.onDrop}
        onDragEnter={this.suppress}
        onDragOver={this.suppress}
      >
        {this.props.children}
      </div>
    );
  }
}
